import { Observable } from 'rxjs';
import { Microsoft365LicensesFieldConfig } from '../../../shared/models/generated/ziroModels';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable()
export class MicrosoftLicensesConfigsResource {
  private http = inject(HttpClient);

  getLicensesConfig(tenantId: string): Observable<Microsoft365LicensesFieldConfig> {
    return this.http.get<Microsoft365LicensesFieldConfig>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/field-configs/365-licenses`,
    );
  }
}
